module.exports = __webpack_public_path__ + "static/media/gymate4.e08e900f.gif";